import AppSettingsCard from '../AppSettingsCard';
import LogoutButton from '../LogoutButton';
import MchdCard from '../MchdCard';
import OrganizationCard from '../OrganizationCard';
import OrganizationWarehousesButton from '../OrganizationWarehousesButton';
import ProfileCard from '../ProfileCard';
import ProfileSection from '../ProfileSection';
import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ProfileLayoutProps } from './types';
import { useBrandTheme } from '@/shared/theme';

const ProfileLayout = (props: ProfileLayoutProps) => {
  const {
    hasOrganization,
    isMchdLoading,
    isOrganizationLoading,
    isProfileLoading,
    logout,
    mchdItems,
    mchdRequires,
    mchdTotalCount,
    navigate,
    orgId,
    onOpenOrganizationWarehouses,
    onOpenProfileEdit,
    organization,
    profile
  } = props;

  const { isDark, toggle } = useBrandTheme();

  const onClickAddOrganization = (): void => {
    navigate('/register/organization', { state: { returnTo: '/profile' } });
  };

  return (
    <>
      <ProfileCard
        isLoading={isProfileLoading}
        onOpenProfileEdit={onOpenProfileEdit}
        profile={profile}
      />

      <div className="flex flex-col gap-8">
        <ProfileSection title="Организация">
          {hasOrganization ? (
            <OrganizationCard
              isLoading={isOrganizationLoading}
              navigate={navigate}
              organization={organization}
            />
          ) : (
            <article className="flex flex-col gap-2 p-4 rounded-2xl border border-border-strong bg-surface">
              <div className="flex items-start gap-2">
                <div className="flex size-8 shrink-0 items-center justify-center rounded-[8px] bg-[#13100d0d] dark:bg-[#ffffff0d]">
                  <Building2 className="size-4 text-foreground" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-sans text-[16px] font-semibold leading-5 tracking-normal text-foreground">
                    Нет организации
                  </h3>
                  <p className="mt-1 text-xs leading-4 text-muted-foreground">
                    Добавьте организацию, чтобы создать первую поставку
                  </p>
                </div>
              </div>
              <Button
                className="w-full"
                onClick={onClickAddOrganization}
              >
                Добавить организацию
              </Button>
            </article>
          )}
        </ProfileSection>

        {hasOrganization ? (
          <>
            <MchdCard
              email={profile.email}
              isLoading={isMchdLoading}
              items={mchdItems}
              orgId={orgId}
              requiresMchd={mchdRequires}
              totalCount={mchdTotalCount}
            />
            <OrganizationWarehousesButton onOpenOrganizationWarehouses={onOpenOrganizationWarehouses} />
          </>
        ) : null}
      </div>

      <AppSettingsCard
        isDark={isDark}
        toggle={toggle}
      />

      <LogoutButton logout={logout} />
    </>
  );
};

export default ProfileLayout;